// extracted by mini-css-extract-plugin
export default {"styles":"WHHeader_styles__D4tL5"};